import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { global_actions } from "../../../../redux-store";
import { Notification } from "../../../../utils";
import backend from "../../../../api";
import ClipLoader from "react-spinners/ClipLoader";
import { Helmet } from "react-helmet";
import EarningAnalytics from "./Earnings/EarningAnalytics";
import CountWidget from "../../../common/cards/CountWidget";
import TransactionListing from "./Earnings/TransactionListing";
import RequestWithdrawal from "./Earnings/RequestWithdrawal";
import { Info } from "@mui/icons-material";
import { Card, CardContent, CardHeader, Tooltip } from "@material-ui/core";
import { formatPrice } from "../../../../utils/formatPrice";
import { toast } from "react-toastify";
import { Tab, Tabs } from "@mui/material";

const Earnings = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { loading } = useSelector((state) => state.global);

  const [userEarnings, setUserEarnings] = useState({});

  const [activeTab, setActiveTab] = useState("e-money");

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const getEarning = async (activeTab) => {
    dispatch(global_actions.loading(true));

    const params = {
      user: user?.user?._id,
      // order_pos: false,
    };

    // if (user?.user?.role === "member") {
    //   delete params.order_pos;
    // }

    try {
      const endPoints =
        activeTab === "e-money"
          ? "/eMoney-userwallet/earning"
          : "/userwallet/earning";
      const response = await backend.get(endPoints, { params });
      // const { connectEarning, eMoneyEarning } = response?.data;
      setUserEarnings(response?.data?.data);
    } catch (error) {
      toast.error(error.response ? error.response.data.message : error.message);
    } finally {
      dispatch(global_actions.loading(false));
    }
  };

  const widgetData = {
    "e-money": [
      {
        title: "Balance",
        value: `${formatPrice(userEarnings?.balance || 0)}`,
      },
      {
        title: "Recieved",
        value: `${formatPrice(userEarnings?.receivedAmount || 0)}`,
      },
      {
        title: "Spent",
        value: `${formatPrice(userEarnings?.spentAmount || 0)}`,
      },
    ],
    "bank-account": [
      {
        title: "Balance",
        value: `${formatPrice(userEarnings?.balance || 0)}`,
      },
      {
        title: "Recieved",
        value: `${formatPrice(userEarnings?.receivedAmount || 0)}`,
      },
      {
        title: "Withdrawn",
        value: `${formatPrice(userEarnings?.withdrawnAmount || 0)}`,
      },
    ],
  };

  const params = useMemo(
    () => ({
      user,
      activeTab,
    }),
    [user, activeTab]
  );

  useEffect(() => {
    if (user && user.user._id) {
      getEarning(activeTab);
    }
  }, [params]);

  return (
    <>
      <Helmet>
        <title>eksplode! | Earnings</title>
      </Helmet>
      {loading ? (
        <div className="dashboard">
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <ClipLoader color={"#000000"} loading={loading} size={60} />
            </div>
          </div>
        </div>
      ) : (
        <div className="dashboard">
          <div className="page-title d-flex flex-wrap justify-content-between mb-3">
            <h2>My Earnings</h2>
          </div>
          <div className="row">
            <div className="col-12 mb-3">
              <Tabs value={activeTab} onChange={handleChange}>
                <Tab value="e-money" label="E-money" />
                <Tab value="bank-account" label="Bank Account" />
              </Tabs>
            </div>
            {widgetData[activeTab]?.map((el, index) => {
              return (
                <div className="col-4 mb-3" key={index}>
                  <CountWidget data={el} />
                </div>
              );
            })}
            {/* <div className="col-12 mb-3">
              <EarningAnalytics />
            </div> */}
            <div className="col-12">
              <TransactionListing activeTab={activeTab} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Earnings;
